// Permissions that grant access to at least one panel of the Generic Base Message
// page. The left-hand "Generic Base Types" (products) list is the selector that
// drives the message list and the exclusion list, so it is shown to anyone who
// can list any of them - otherwise granting only `generic-base-message:list`
// leaves the user on a page with nothing selectable.
export const GENERIC_BASE_PAGE_SCOPES = [
  'is-admin',
  'generic-base-type:list',
  'generic-base-message:list',
  'generic-base-company-exception:list',
];

export const GENERIC_BASE_PAGE_SCOPE = GENERIC_BASE_PAGE_SCOPES.join(',');
